package com.far.suller.models

import com.far.suller.util.Constants.ANIMELOOM
import com.far.suller.util.Constants.CURRENZY
import com.far.suller.util.Constants.FLEET_DRIVE_BACKOFFICE
import com.far.suller.util.Constants.MCDELIVERY_LINK
import com.far.suller.util.Constants.SOLODAILY
import com.far.suller.util.Constants.SOLOEATS
import com.far.suller.util.Constants.SOLOFOLIO
import com.far.suller.util.Constants.SOLOSCAPE
import com.far.suller.util.Constants.UNIONBANK
import com.far.suller.util.Res

enum class Portfolio(
    val image: String,
    val title: String,
    val description: String,
    val link: String,
    val isWeb: Boolean = false,
    val extraImages: List<String> = emptyList(),
) {
    FleetDriveBackoffice(
        image = Res.Image.fleetDrive1,
        title = "Fleet Drive Backoffice",
        description = "A comprehensive fleet management platform built for real-time tracking, vehicle diagnostics, and operational oversight. Featuring a high-performance web dashboard with dynamic data visualization.",
        link = FLEET_DRIVE_BACKOFFICE,
        isWeb = true,
        extraImages = listOf(Res.Image.fleetDrive2),
    ),
    AnimeLoom(
        image = Res.Image.animeloom,
        title = "AnimeLoom",
        description = "AnimeLoom delivers a seamless experience for anime and manga lovers, offering comprehensive details, summaries, and insights on your favorite series. Explore, bookmark, and stay updated with ease",
        link = ANIMELOOM,
    ),
    Currenzy(
        image = Res.Image.currenzy,
        title = "Currenzy",
        description = "\"Currenzy\" is a straightforward currency converter app that allows users to check live exchange rates " +
            "and easily convert between different currencies with a simple, user-friendly interface.",
        link = CURRENZY,
    ),
    SoloScape(
        image = Res.Image.soloscape,
        title = "SoloScape",
        description = "SoloScape - Version 1.0 \n" +
            "Introducing the first version of my Jetpack Compose app, now live on the Play Store—a straightforward journal app.",
        link = SOLOSCAPE,
    ),
    Solofolio(
        image = Res.Image.solofolio,
        title = "Solofolio",
        description = "Solofolio - Version 1.0 \n" +
            "Jetpack Compose Upgrade: SoloFolio is now revamped using Jetpack Compose for a more modern and dynamic portfolio experience.",
        link = SOLOFOLIO,
    ),
    SoloEats(
        image = Res.Image.soloeats,
        title = "SoloEats",
        description = "SoloEats - Version 1.0 \n" +
            "SoloEats 1.0 is a demo version, not processing real transactions. The release emphasizes an effortless dining experience.",
        link = SOLOEATS,
    ),
    SoloDaily(
        image = Res.Image.solodaily,
        title = "SoloDaily",
        description = "SoloDaily - Version 1.0 \n" +
            "Browse Latest News: Stay up-to-date with breaking news and trending stories from around the world. Search Functionality: Easily find articles on topics that interest you with our intuitive search feature. Bookmark Articles: Save articles for later reading with our convenient bookmarking feature.",
        link = SOLODAILY,
    ),
    UnionBankApp(
        image = Res.Image.portfolio5,
        title = "UnionBank Online",
        description = "I was part of a specific team that developed a feature related to installments, deployed it on the app for users, and subsequently maintained other features within different teams.",
        link = UNIONBANK,
    ),
    McDeliveryPH(
        image = Res.Image.portfolio3,
        title = "McDelivery PH",
        description = "During my tenure at the previous company, our team revamped and released the McDelivery PH app to the market.",
        link = MCDELIVERY_LINK,
    ),
}
